export interface ChargeRow {
  titleKey: string;
  value: string;
}

// One owner for how a charge is broken down, so the confirm screen and the
// receipt cannot drift apart and show a payer two different stories about
// the same money. Returns translation keys, not text: this layer is pure
// and may not reach for i18n or a component type.
export const getChargeRows = (
  instrumentFee: string,
  registrationFee: string,
  totalFees: string
): ChargeRow[] => {
  // Coerced to a number deliberately: these arrive as strings, and the
  // string "0" is truthy, so a truthiness test would keep a zero row.
  const charged = [
    { titleKey: "payment.form.instrument_fee", value: instrumentFee },
    { titleKey: "payment.form.registration_fee", value: registrationFee },
  ].filter(component => Number(component.value) > 0);

  // A lone component always equals the total, so listing it would show the
  // same figure twice under two names. Break down only what has parts.
  const components = charged.length > 1 ? charged : [];

  return [
    ...components,
    { titleKey: "payment.form.total_charge", value: totalFees },
  ];
};

export default getChargeRows;
